import { cn } from '@/shared/lib/cn';

const SIZES = {
  sm: 'size-12 [&>svg]:size-6',
  default: 'size-20 [&>svg]:size-10',
  lg: 'size-32 [&>svg]:size-16',
} as const;

export interface BrandMarkProps {
  size?: keyof typeof SIZES;
  /** Adds the halo ring seen on the payment screens. */
  halo?: boolean;
  className?: string;
}

/**
 * The app's bolt mark on its tinted disc — the recurring hero element of the
 * payment and auth screens. Inline SVG so it inherits `currentColor` and needs
 * no network request on the critical path.
 */
export function BrandMark({ size = 'default', halo = false, className }: BrandMarkProps) {
  return (
    <span
      className={cn(
        'bg-primary-muted text-primary relative flex items-center justify-center rounded-full',
        halo && 'ring-primary/70 ring-2 ring-offset-4 ring-offset-transparent',
        SIZES[size],
        className,
      )}
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden focusable="false">
        <path
          d="M13.8 2.4a.8.8 0 0 1 1.36.68l-.86 5.16a.8.8 0 0 0 .79.93h3.44c.71 0 1.06.86.55 1.36l-8.88 8.88a.8.8 0 0 1-1.36-.68l.86-5.16a.8.8 0 0 0-.79-.93H5.47c-.71 0-1.06-.86-.55-1.36L13.8 2.4Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

/** Wordmark used in the login header and the account footer. */
export function BrandWordmark({ className }: { className?: string }) {
  return (
    <span className={cn('flex items-center gap-2 font-bold', className)}>
      <BrandMark size="sm" className="size-9 [&>svg]:size-4.5" />
      شارژر
    </span>
  );
}
